// Public settings that depend on external accounts. Every form falls back to
// an email flow when its embed is empty.
export const commerceConfig = Object.freeze({
    inquiryEmail: 'jeremy@studio-3000.com'
});

export const newsletterConfig = Object.freeze({
    forms: Object.freeze({
        // This Week in the Lab signup (landing page and /lab/). Paste the whole
        // Beehiiv embed snippet inside the backticks, exactly as provided.
        lab: Object.freeze({
            embedCode: `<script async src="https://subscribe-forms.beehiiv.com/v3/loader.js" data-beehiiv-form="02106dd2-7950-488e-bfd1-edf9e19587de"></script>`,
            embedUrl: ''
        }),
        // Guide signup: configure its Beehiiv success redirect to /thank-you/.
        guide: Object.freeze({
            embedCode: `<script async src="https://subscribe-forms.beehiiv.com/v3/loader.js" data-beehiiv-form="455f2cdf-e46f-498f-a4e4-871b608ad154"></script>`,
            embedUrl: ''
        })
    }),
    // Beehiiv publication archive URL
    archiveUrl: 'https://this-week-in-the-lab.beehiiv.com'
});
